import useAxiosMutation from 'hooks/useAxiosMutation';
import { useQueryClient } from 'react-query';
import { BLUEPRINT_SHARED_TOKEN_CACHE_KEY } from 'services/queryKeys';

type RevokeSharedBlueprintParams = {
  shareToken: string;
  blueprintId: number;
};

export const useRevokeSharedBlueprint = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, mutate, isLoading, isError, error } = useAxiosMutation<void>();

  const revokeSharedBlueprint = async ({ shareToken, blueprintId }: RevokeSharedBlueprintParams) => {
    const result = await mutateAsync({
      method: 'DELETE',
      path: `/blueprints/shared/${shareToken}/`,
      body: {},
    });

    // Invalidate the shared token cache after successful revocation
    queryClient.invalidateQueries(BLUEPRINT_SHARED_TOKEN_CACHE_KEY(blueprintId));

    return result;
  };

  return {
    revokeSharedBlueprint,
    mutate,
    isLoading,
    isError,
    error,
  };
};
